import { Button } from "@mui/material";
import { useStripe, useElements, PaymentElement, AddressElement } from "@stripe/react-stripe-js";
import {  Dispatch, SetStateAction, useState } from "react";
import { useToast } from "../../../Hooks/useToast";
import { useAppDispatch } from "../../../Redux/store";
import { stripeApi } from "../../../Redux/api/stripeApi";
import { useUser } from "../../../Hooks/useUser";
import { KaziButton } from "../../../Shared Components/Kazi/KaziButton";
import { setShowAddPaymentMethodModal } from "../../../Redux/slices/GlobalModalSlice";

interface IProps {}

export const SetupForm = ({}:IProps) => {
    /* ******************** Hooks ******************** */
    const dispatch = useAppDispatch();
    const stripe = useStripe();
    const elements = useElements();
    const { showToast } = useToast();
    const { user } = useUser();
    /* ******************** Variables ******************** */
    const [errorMessage, setErrorMessage] = useState<String | undefined>(undefined);
    const [isLoading, setIsLoading] = useState(false);
    /* ******************** Functions ******************** */
    const handleSubmit = async (event: any) => {
        event.preventDefault();
        if (!stripe || !elements) {
            return null;
        }
        setIsLoading(true);
        const {error} = await stripe.confirmSetup({
            elements,
            redirect: 'if_required',
            confirmParams: {
                payment_method_data: {
                    allow_redisplay: 'always',
                    billing_details: {
                        email: user?.email
                    }
                }
            }
        });
        if (error) {
            // This point will only be reached if there is an immediate error when
            // confirming the payment. Show error to your customer (for example, payment
            // details incomplete)
            setErrorMessage(error.message);
            setIsLoading(false);
          } else {
            // Your customer will be redirected to your `return_url`. For some payment
            // methods like iDEAL, your customer will be redirected to an intermediate
            // site first to authorize the payment, then redirected to the `return_url`.
            setIsLoading(false);
            showToast({
                text: 'Account connected!'
            })
            dispatch(setShowAddPaymentMethodModal(false));
            dispatch(stripeApi.util.invalidateTags(['DefaultPaymentMethod']));
          }
    }
    /* ******************** Effects ******************** */
    /* ******************** JSX ******************** */
    return (
        <>
            <PaymentElement options={{
                layout: 'accordion'
            }}/>
            <AddressElement options={{mode: 'billing'}}/>
            <KaziButton 
                text='Submit'
                loading={{
                    isLoading: isLoading,
                    loadingText: 'Adding payment method...',
                    color: 'secondary'
                }}
                variant='contained' 
                sx={{marginTop: 2}} 
                disabled={!stripe} 
                onClick={handleSubmit}
            />
            {errorMessage && <div>{errorMessage}</div>}
        </>
    )
}